<ng-container [ngSwitch]="_type">
  <mat-form-field
    class="w-full"
    *ngSwitchCase="'string'"
    testId="attribute-input-string"
  >
    <mat-label>{{ label }}</mat-label>
    <input matInput [formControl]="formControl" />
  </mat-form-field>
  <mat-form-field
    class="w-full"
    *ngSwitchCase="'number'"
    testId="attribute-input-number"
  >
    <mat-label>{{ label }}</mat-label>
    <input matInput [formControl]="formControl" type="number" />
  </mat-form-field>
  <mat-form-field
    class="w-full"
    *ngSwitchCase="'boolean'"
    testId="attribute-input-boolean"
  >
    <mat-label>{{ label }}</mat-label>
    <mat-select [formControl]="formControl">
      <mat-option [value]="true">Yes</mat-option>
      <mat-option [value]="false">No</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field
    class="w-full"
    *ngSwitchCase="'date'"
    testId="attribute-input-date"
  >
    <mat-label>{{ label }}</mat-label>
    <input matInput [formControl]="formControl" [matDatepicker]="picker" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</ng-container>
